export default function objectMatch(obj1, obj2) {
  // TODO: implement this without JSON.stringify
  return JSON.stringify(obj1) === JSON.stringify(obj2);
}
